import {
  BibliographyRealDetailBibliography,
  BibliographyRealDetailBibliographyFromJSON,
  defaultBibliographyRealDetailBibliography,
  BibliographyRealDetailCollection,
  BibliographyRealDetailCollectionFromJSON,
  BibliographyRealDetailMarc,
  BibliographyRealDetailMarcFromJSON,
  BibliographyRealDetailReserve,
  BibliographyRealDetailReserveFromJSON,
  BibliographyDetailDetail,
  BibliographyDetailDetailFromJSON,
  BibliographyRealDetailContent,
  BibliographyRealDetailContentFromJSON,
  BibliographyDetailAuthority,
  BibliographyAuthorityFromJSON,
  BibliographyRealDetailOrder,
  BibliographyRealDetailOrderFromJSON
} from '.'

export interface BibliographyRealDetail {
  bibliography: BibliographyRealDetailBibliography
  collections: BibliographyRealDetailCollection[]
  orders: BibliographyRealDetailOrder[]
  reserves: BibliographyRealDetailReserve[]
  details: BibliographyDetailDetail[]
  authorities: BibliographyDetailAuthority[]
  contents: BibliographyRealDetailContent[]
  marcs: BibliographyRealDetailMarc[]
}

export function BibliographyRealDetailFromJSON(
  json: any
): BibliographyRealDetail {
  if (Array.isArray(json)) {
    return defaultBibliographyRealDetail()
  }

  return {
    bibliography: BibliographyRealDetailBibliographyFromJSON(json.bibliography),
    collections: json.collections.map(BibliographyRealDetailCollectionFromJSON),
    orders: json.orders.map(BibliographyRealDetailOrderFromJSON),
    reserves: json.reserves.map(BibliographyRealDetailReserveFromJSON),
    details: json.bibliography_details.map(BibliographyDetailDetailFromJSON),
    authorities: json.bibliography_authorities.map(
      BibliographyAuthorityFromJSON
    ),
    contents: json.bibliography_contents.map(
      BibliographyRealDetailContentFromJSON
    ),
    marcs: json.marcs.map(BibliographyRealDetailMarcFromJSON)
  }
}

export const defaultBibliographyRealDetail = (): BibliographyRealDetail => ({
  bibliography: defaultBibliographyRealDetailBibliography(),
  collections: [],
  orders: [],
  reserves: [],
  details: [],
  authorities: [],
  contents: [],
  marcs: []
})
